<script lang="ts">
    import { faCalendarAlt, faCaretDown } from '@fortawesome/free-solid-svg-icons'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    dayjs.extend(utc)
    import { createEventDispatcher } from 'svelte'
    import Zinput from './z/zinput.svelte'
    import Zbutton from './z/zbutton.svelte'
    import ZinputGroup from './z/zinput-group.svelte'
    import Zgrid2Popup from './z/zgrid2_popup.svelte'
    import DateSelectPanel from './date-select-panel.svelte'
    const dispatch = createEventDispatcher()

    let className = ''
    export { className as class }
    export let startFrom: Date = null
    export let startTo: Date = null
    export let small: boolean = false

    let isMobile = screen.width <= 900
    let show = false
    let anchor: HTMLElement = null

    let from: Date = startFrom ? new Date(startFrom) : null
    let to: Date = startTo ? window.api.utils.dates.setDateToLastSecondFromDate(new Date(startTo)) : null
    if (!from || !to) {
        const month = window.api.utils.dates.currentMonth()
        from = month.from
        to = month.to
    }

    // o painel devolve datas do jeito que o usuário mexeu (as setas preservam o dia); aqui vira mês cheio
    function onApply(event: CustomEvent<{ from: Date; to: Date }>) {
        from = dayjs(event.detail.from).startOf('month').toDate()
        to = window.api.utils.dates.setDateToLastSecondFromMonth(event.detail.to)
        show = false
        dispatch('change', { from, to })
    }

    // função chamada fora
    export function setDate(_from, _to) {
        _from.setHours(0, 0, 0, 0)
        from = new Date(_from)
        to = window.api.utils.dates.setDateToLastSecondFromDate(_to)
    }
</script>

<div class="zdate-select zdate-select-month {className}">
    <div class="h-screen me-3">
        Período selecionado: {dayjs(from).format('MM/YYYY')} até {dayjs(to).format('MM/YYYY')}
    </div>

    <div class="date-show h-print" bind:this={anchor}>
        {#if !isMobile}
            <ZinputGroup>
                <Zinput type="month" value={from} label="De" disabled={true}></Zinput>
                <Zinput type="month" value={to} label="Até" disabled={true}></Zinput>
                <Zbutton on:click={() => (show = !show)} icon={faCaretDown} title="Escolher período"></Zbutton>
            </ZinputGroup>
        {:else}
            <Zbutton on:click={() => (show = !show)} icon={faCalendarAlt} title="Escolher período"></Zbutton>
        {/if}
    </div>

    {#if show}
        <div class="h-print">
            <Zgrid2Popup {anchor} width={300} on:close={() => (show = false)}>
                <DateSelectPanel mode="month" {from} {to} on:apply={onApply} />
            </Zgrid2Popup>
        </div>
    {/if}
</div>
